<!--
 * @Author: your name
 * @Date: 2020-09-30 10:05:45
 * @LastEditTime: 2022-05-19 16:07:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/privacy/index.vue
-->
<template>
  <div class="privacy">
    <div v-if="protocol" v-html="protocol"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  data() {
    return {
      protocol: null,
    };
  },
  created() {
    this.getQuestionsProtocol();
  },
  methods: {
    // 服务协议
    getQuestionsProtocol() {
      // 服务协议
      axios.get(`/designer_api/questions/privacy`).then((res) => {
        this.protocol = res.content;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.privacy {
  padding: 20px;
  width: 100%;
}
</style>
